'use client'

export enum TabValue {
  ROOM_INFORMATION = 'room-information',
  CONTRACT_INFORMATION = 'contract-information',
  REVIEW = 'review',
  HOST_INFORMATION = 'host-information',
}

export const TABS = [
  {
    label: '방 정보',
    value: TabValue.ROOM_INFORMATION,
  },
  {
    label: '계약 정보',
    value: TabValue.CONTRACT_INFORMATION,
  },
  {
    label: '후기',
    value: TabValue.REVIEW,
  },
  {
    label: '호스트 정보',
    value: TabValue.HOST_INFORMATION,
  },
]

export const CONTRACT_ROOM_TABS = [
  {
    label: '방 정보',
    value: TabValue.ROOM_INFORMATION,
  },
  {
    label: '계약 정보',
    value: TabValue.CONTRACT_INFORMATION,
  },
]
